module.exports = __webpack_public_path__ + "static/media/Cadila-Logo-en.d7d599ee.svg";